/**
 * MODAL windows
 * Initializes modal functionality for elements with data-p-open-modal attributes
 */
$(function () {
  // Cache DOM elements
  const modalBackground = document.querySelector(".modal-background");
  const modalTriggers = document.querySelectorAll("[data-open-modal]");
  const closeButtons = document.querySelectorAll("[data-modal-close]");
  const modalElements = document.querySelectorAll(".modal");

  // Early return if required elements are missing
  if (!modalBackground) {
    console.warn("Modal background element not found");
    return;
  }

  // Store event handlers for cleanup
  const handlers = {
    openModal: new Map(),
    cancelModal: new Map(),
    clickModal: new Map(),
    backgroundClick: null,
  };

  // Handle modal opening
  const handleModalOpen = (event) => {
    event.preventDefault();
    const selector = event.currentTarget.getAttribute("data-open-modal");

    if (!selector) {
      console.warn("Error: data-open-modal attribute is empty");
      return;
    }

    const targetModal = document.querySelector(selector);
    if (!targetModal) {
      console.warn(`Error: No modal found with selector "${selector}"`);
      return;
    }

    // Reset iframe source to force reload if it's the jobs modal
    if (selector === "#jobs-modal") {
      const iframe = document.getElementById("elmo-modal-iframe");
      if (iframe) {
        iframe.src = iframe.src;

        // Initialize iframe resizer when modal is shown
        const observer = new MutationObserver(function (mutations) {
          if (targetModal.classList.contains("active")) {
            // Initialize iframe resizer
            if (typeof iFrameResize === "function") {
              iFrameResize(
                {
                  log: true,
                  checkOrigin: false,
                  heightCalculationMethod: "max",
                  minHeight: 600,
                  maxHeight: function () {
                    return window.innerHeight - 100;
                  },
                },
                "#elmo-modal-iframe",
              );
            }
            observer.disconnect();
          }
        });

        observer.observe(targetModal, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }
    }

    modalBackground.classList.add("nowactive");
    document.body.classList.add("modal-opened");
    targetModal.classList.add("active");
  };

  // Handle modal closing
  const handleModalClose = (event) => {
    event.preventDefault();
    const activeModal = document.querySelector(".modal.active");
    if (activeModal) {
      // Clean up iframe resizer if it's the jobs modal
      if (
        activeModal.id === "jobs-modal" &&
        typeof iFrameResize !== "undefined"
      ) {
        const iframe = document.getElementById("elmo-modal-iframe");
        if (iframe && iframe.iFrameResizer) {
          iframe.iFrameResizer.close();
        }
      }

      activeModal.classList.remove("active");
      modalBackground.classList.remove("nowactive");
      document.body.classList.remove("modal-opened");
    }
  };

  // Handle modal content click (prevent propagation)
  const handleModalClick = (event) => {
    event.stopPropagation();
  };

  // Handle background click
  const handleBackgroundClick = (event) => {
    event.preventDefault();
    const openedModal = document.querySelector(".modal.active");

    if (openedModal?.getAttribute("data-p-close-on-outside") === "true") {
      event.stopPropagation();
      openedModal.classList.remove("active");
      modalBackground.classList.remove("nowactive");
      document.body.classList.remove("modal-opened");
    }
  };

  // Add event listeners
  modalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", handleModalOpen);
    handlers.openModal.set(trigger, handleModalOpen);
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", handleModalClose);
    handlers.cancelModal.set(button, handleModalClose);
  });

  modalElements.forEach((modal) => {
    modal.addEventListener("click", handleModalClick);
    handlers.clickModal.set(modal, handleModalClick);
  });

  modalBackground.addEventListener("click", handleBackgroundClick);
  handlers.backgroundClick = handleBackgroundClick;

  // Return cleanup function
  return () => {
    // Remove modal trigger listeners
    modalTriggers.forEach((trigger) => {
      const handler = handlers.openModal.get(trigger);
      trigger.removeEventListener("click", handler);
    });

    // Remove close button listeners
    closeButtons.forEach((button) => {
      const handler = handlers.cancelModal.get(button);
      button.removeEventListener("click", handler);
    });

    // Remove modal click listeners
    modalElements.forEach((modal) => {
      const handler = handlers.clickModal.get(modal);
      modal.removeEventListener("click", handler);
    });

    // Remove background click listener
    if (modalBackground && handlers.backgroundClick) {
      modalBackground.removeEventListener("click", handlers.backgroundClick);
    }

    // Clear handler maps
    handlers.openModal.clear();
    handlers.cancelModal.clear();
    handlers.clickModal.clear();
    handlers.backgroundClick = null;
  };
});
